import React from 'react';
import { TextField } from 'react-md';
export default class FrmCambiarContrasena extends React.Component {
   

    render() {
        return (
            <div className="ARC_Lgn_dv">
                <TextField id="IdNewPass" type="password" label="Nueva contraseña" lineDirection="center"
                className="lg-cell lg-cell--bottom" />
                <TextField id="IdConfPass"
                type="password"
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        this.eventEnter();
                    }
                }}
                label="Confirmar contraseña" lineDirection="center"
                className="lg-cell lg-cell--bottom" />
            </div>
        )
    }
    eventEnter(){
        this.props.callback(this.props.accion);
    }
}